import script from "./QixinOrder.vue?vue&type=script&lang=ts&setup=true"
export * from "./QixinOrder.vue?vue&type=script&lang=ts&setup=true"

import "./QixinOrder.vue?vue&type=style&index=0&id=ad11dd72&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad11dd72"]])

export default __exports__